import React, { Component } from "react";
import { observer } from "mobx-react";

import { IConfirm } from "../store/IAppStore";
import { appStore } from "../stores";
import { Buttons } from "./common/Buttons";
import { Escape } from "./common/Escape";
import { FlexSpacer } from "./common/FlexSpacer";
import { Heading3 } from "./common/Heading3";
import { Popup } from "./common/Popup";
import { StandardButton } from "./common/StandardButton";
import * as styles from "./ConfirmPopup.scss";

@observer
export class ConfirmPopup extends Component {
    private message: IConfirm | undefined;

    public render() {
        const message = appStore.confirm || this.message;
        this.message = message;
        const visible = !!appStore.confirm;
        const { onCancel, onOk } = this;
        return (
            <Popup visible={visible} windowClassName={styles["confirm-popup"]}>
                <Escape onEsc={onCancel} />
                <Heading3 className={styles.heading}>
                    {message?.title}
                    {message?.titleHelp && (
                        <div className={styles.help}>{message?.titleHelp}</div>
                    )}
                </Heading3>
                <div className={styles.message}>{message?.message}</div>
                <Buttons className={styles.actions}>
                    <FlexSpacer />
                    <StandardButton
                        onClicked={onCancel}
                        dark={true}
                        data-testid="confirm-cancel-button"
                    >
                        {message?.cancelCopy || "Cancel"}
                    </StandardButton>
                    <StandardButton
                        primary={true}
                        onClicked={onOk}
                        data-testid="confirm-ok-button"
                        critical={message?.critical}
                    >
                        {message?.okCopy || "OK"}
                    </StandardButton>
                </Buttons>
            </Popup>
        );
    }

    private onCancel = () => {
        appStore.setConfirm(undefined);
        this.message?.onCancel?.();
    };

    private onOk = () => {
        const { message } = this;
        if (!message) {
            return;
        }
        appStore.setConfirm(undefined);
        message.onOk();
    };
}
